import { render, staticRenderFns } from "./singleColumn.vue?vue&type=template&id=4c8e1b56&"
import script from "./singleColumn.vue?vue&type=script&lang=js&"
export * from "./singleColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports